import { RTLObserver } from "@ingka/webc-tools";
import { SkapaElement } from "@ingka/skapa-webc-element";
const styles = ':host{display:inline-flex}:host([fluid]){width:100%}';
const lightStyle = 'skapa-toggle{--skapa-toggle-inline-first-border:4px 0px 0px 4px;--skapa-toggle-inline-last-border:0px 4px 4px 0px}skapa-toggle[skapa-rtl]{--skapa-toggle-inline-first-border:0px 4px 4px 0px;--skapa-toggle-inline-last-border:4px 0px 0px 4px}skapa-toggle[fluid]>button{width:100%}skapa-toggle>button{all:initial;background:#0000;border:1px solid rgb(var(--colour-neutral-4,204,204,204));color:rgb(var(--colour-text-and-icon-1,17,17,17));cursor:pointer;font-family:inherit;font-size:.75rem;font-weight:700;line-height:1.5;min-height:1.875rem;padding:0 .75rem;position:relative;text-align:center}skapa-toggle>button:focus{outline:none}skapa-toggle>button>skapa-icon{margin-bottom:.125rem;margin-top:.125rem}skapa-toggle>button:after{bottom:-.5rem;content:"";display:block;left:0;position:absolute;top:-.5rem;width:100%}skapa-toggle>button:hover{border-color:rgb(var(--colour-neutral-5,146,146,146));z-index:1}skapa-toggle>button[aria-pressed=true]{z-index:2}skapa-toggle>button[aria-pressed=true],skapa-toggle>button[aria-pressed=true]:hover{border-color:rgb(var(--colour-interactive-subtle-border-selected,17,17,17))}skapa-toggle>button:disabled,skapa-toggle>button:disabled:hover{border-color:rgb(var(--colour-interactive-disabled-1,204,204,204));color:rgb(var(--colour-interactive-disabled-1,204,204,204));cursor:default}skapa-toggle>button:focus-visible{box-shadow:0 0 0 4px var(--skapa-focus-ring-internal,rgb(var(--colour-neutral-1,255,255,255)));outline:2px solid var(--skapa-focus-ring-external,rgb(var(--colour-neutral-7,17,17,17)));outline-offset:4px;transition:outline .2s ease-out,box-shadow .2s ease-out}skapa-toggle>button:not(:first-child){margin-inline-start:-1px}skapa-toggle>button:first-of-type{border-radius:var(--skapa-toggle-inline-first-border)}skapa-toggle>button:last-of-type{border-radius:var(--skapa-toggle-inline-last-border)}@media (forced-colors:active){skapa-toggle:disabled,skapa-toggle:disabled:hover{border-color:GrayText;color:GrayText}}';
function generateTemplate({ html, prefixReplacer }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <slot></slot>
    <slot name="light-style"></slot>
  `;
  const lightStyleTemplate = document.createElement("style");
  lightStyleTemplate.slot = "light-style";
  lightStyleTemplate.innerHTML = prefixReplacer(lightStyle.toString());
  return { main: template, lightStyleTemplate };
}
function setDisabled(items, disabled) {
  items.forEach((item) => item.disabled = disabled);
}
function setActiveIndex(items, index) {
  items.forEach(
    (item, i) => item.setAttribute("aria-pressed", (i === index).toString())
  );
}
class Toggle extends SkapaElement {
  constructor() {
    super();
    this.updateChildren = () => {
      setDisabled(this.items, this.disabled);
      setActiveIndex(this.items, this.activeIndex);
    };
    this.handleSlotChange = (ev) => {
      setDisabled(this.items, this.disabled);
      setActiveIndex(this.items, this.activeIndex);
    };
    this.gatherProperties(["activeIndex", "disabled", "fluid"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const { main, lightStyleTemplate } = this.getTemplates(generateTemplate);
    shadow.append(main.content.cloneNode(true));
    this.shadowSlot = shadow.querySelector("slot");
    this.lightStyleElement = lightStyleTemplate.cloneNode(
      true
    );
  }
  static get observedAttributes() {
    return ["active-index", "disabled"];
  }
  connectedCallback() {
    super.connectedCallback();
    RTLObserver.addTarget(this);
    this.shadowSlot.addEventListener("slotchange", this.handleSlotChange);
    this.addEventListener("click", this.handleSelect);
    this.append(this.lightStyleElement);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    RTLObserver.removeTarget(this);
    this.shadowSlot.removeEventListener("slotchange", this.handleSlotChange);
    this.removeEventListener("click", this.handleSelect);
  }
  get activeIndex() {
    if (!this.hasAttribute("active-index"))
      return -1;
    return parseInt(this.getAttribute("active-index"), 10);
  }
  set activeIndex(value) {
    if (Number.isNaN(value) || value < 0)
      this.removeAttribute("active-index");
    else
      this.setAttribute("active-index", value.toString());
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(val) {
    this.toggleAttribute("disabled", !!val);
  }
  get fluid() {
    return this.hasAttribute("fluid");
  }
  set fluid(val) {
    this.toggleAttribute("fluid", !!val);
  }
  attributeChangedCallback(attributeName) {
    if (attributeName === "disabled")
      setDisabled(this.items, this.disabled);
    else {
      setActiveIndex(this.items, this.activeIndex);
      this.dispatchEvent(
        new CustomEvent("skapa-toggle-change", { detail: this.activeIndex })
      );
    }
  }
  get items() {
    return Array.from(this.querySelectorAll("button"));
  }
  handleSelect(ev) {
    const clickSource = ev.target.closest(
      "button"
    );
    if (clickSource) {
      const index = this.items.indexOf(clickSource);
      if (this.activeIndex !== index)
        this.activeIndex = index;
    }
  }
}
Toggle.skapaTagName = "toggle";
Toggle.skapaDependencies = [];
var Toggle_default = Toggle;
export {
  Toggle,
  Toggle_default as default
};
